var _path, _polygon, _polygon2, _polygon3, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SaintVincentAndTheGrenadinesCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffca28",
    d: "M23.989,44c4.07,0,7.852-1.223,11.011-3.311V7.311C31.841,5.223,28.06,4,23.989,4 C19.928,4,16.155,5.219,13,7.299v33.403C16.155,42.781,19.928,44,23.989,44z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#007d2a",
    points: "23.308,22.159 20.227,27.478 17.146,22.159 20.227,16.84"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#007d2a",
    points: "30.847,22.159 27.766,27.478 24.685,22.159 27.766,16.84"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#007d2a",
    points: "27.117,28.716 24.036,34.036 20.955,28.716 24.036,23.397"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2e7d32",
    d: "M43.989,24c0-6.975-3.576-13.11-8.989-16.689v33.377C40.414,37.11,43.989,30.975,43.989,24z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#283593",
    d: "M3.989,24c0,6.984,3.586,13.124,9.011,16.701V7.299C7.575,10.876,3.989,17.016,3.989,24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SaintVincentAndTheGrenadinesCircular);
export default __webpack_public_path__ + "static/media/icons8-saint-vincent-and-the-grenadines-circular.23490a4c320532040af0341e3aaf1cb4.svg";
export { ForwardRef as ReactComponent };